if (!customElements.get('cart-button')) {
  class CartButton extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent('alexa:open-cart'));
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this))
    }
  }

  customElements.define('cart-button', CartButton);
}
